"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.$obj = exports.$external = exports.$parent3 = exports.$parent2 = exports.$parent = exports.$root = exports.$methods = exports.JProp = exports.BaseSchemaClass = exports.startdecoratorstime = exports.schemaFuncText = void 0;
exports.runProperty = runProperty;
exports._classToSchema = _classToSchema;
exports.classToSchema = classToSchema;
exports.SchemaArray = SchemaArray;
exports.SchemaNumber = SchemaNumber;
exports.SchemaMoney = SchemaMoney;
exports.SchemaInteger = SchemaInteger;
exports.SchemaString = SchemaString;
exports.SchemaRequired = SchemaRequired;
exports.SchemaBoolean = SchemaBoolean;
exports.SchemaTitle = SchemaTitle;
exports.SchemaFormat = SchemaFormat;
exports.SchemaGuid = SchemaGuid;
exports.SchemaDate = SchemaDate;
exports.SchemaDateTime = SchemaDateTime;
exports.SchemaNip = SchemaNip;
exports.SchemaObject = SchemaObject;
exports.SchemaAggregate = SchemaAggregate;
exports.SchemaDef = SchemaDef;
exports.SchemaClass = SchemaClass;
exports.SchemaOptions = SchemaOptions;
exports.SchemaValidation = SchemaValidation;
require("reflect-metadata");
const schemaFuncText_1 = require("./schemaFuncText");
Object.defineProperty(exports, "schemaFuncText", { enumerable: true, get: function () { return schemaFuncText_1.schemaFuncText; } });
const schemaMethods = __importStar(require("../schemaMethods"));
const fixAndMergeSchema_1 = require("./fixAndMergeSchema");
const IOptions_1 = require("../WrappedProperty/IOptions");
exports.startdecoratorstime = 0;
const eval2 = eval;
class BaseSchemaClass {
    constructor() {
        /**
         * metody schematu
         */
        this.$methods = schemaMethods;
    }
}
exports.BaseSchemaClass = BaseSchemaClass;
// const SCHEMA_METADATA_KEY = Symbol('schema');
// const currentTarget: any = undefined;
function mergeAndFixOptions(prop, options) {
    for (const key of Reflect.ownKeys(options)) {
        const v = options[key];
        // const to = typeof v;
        if (typeof v === 'function') {
            prop[key] = (0, schemaFuncText_1.schemaFuncText)(v.toString());
        }
        else if (key === 'pattern' && v.constructor === RegExp) {
            if (v.source) {
                prop.pattern = v.source;
                if (v.flags === '') {
                    prop.patternFlags = null;
                }
                else if (v.flags != 'i') {
                    //bo domyślnie jest i
                    prop.patternFlags = v.flags;
                }
            }
            //let s = v.toString();
            //if (s.startsWith('/'))
            //    prop[key] = v.toString();
        }
        else {
            prop[key] = v;
        }
    }
}
/**
 * utworzenie/pobranie property o określonej nazwie
 *
 * @param {*} props lista property
 * @param {string} name nazwa property
 * @param {*} target docelowa klasa
 * @param {*} options dodatkowe opcje
 * @returns {*}
 */
function getProperty(props, name, target, options, t) {
    let prop = props[name];
    if (prop === undefined) {
        prop = props[name] = {};
        if (!options || !options.type || t) {
            let ntype;
            if (!t && Reflect.getMetadata) {
                t = Reflect.getMetadata('design:type', target, name);
                if (t) {
                    ntype = t.name;
                    if (ntype === 'Function') {
                        const type2 = Reflect.getMetadata('design:returntype', target, name);
                        if (type2 && type2.name) {
                            ntype = type2.name;
                        }
                    }
                }
            }
            else {
                if (t === 'Array') {
                    ntype = 'Array';
                }
                else {
                    ntype = t.name;
                }
            }
            if (ntype) {
                // let ntype = "array";
                // console.log('prop', name, ntype);
                switch (ntype) {
                    case 'Array':
                        {
                            ntype = '';
                            let atype = options.itemType || 'String';
                            // debugger;
                            // console.log('atype', atype);
                            switch (atype) {
                                case 'String':
                                case String:
                                    atype = 'string';
                                    break;
                                case 'Object':
                                    atype = 'object';
                                    break;
                                case 'Boolean':
                                case Boolean:
                                    atype = 'boolean';
                                    break;
                                case 'Number':
                                case Number:
                                    atype = 'number';
                                    break;
                                case 'money':
                                case 'integer':
                                    break;
                                default: {
                                    // debugger;
                                    if (typeof atype === 'function' && !atype.prototype) {
                                        prop.items = atype.call() || { type: 'string' };
                                    }
                                    else {
                                        if (Array.isArray(atype)) {
                                            atype = atype[0];
                                        }
                                        const stype = ('' + atype).split(' ');
                                        if (stype[0] === 'class' || stype[0] === 'function') {
                                            stype[0] = stype[1].replace('(', '').replace(')', '');
                                        }
                                        // console.log('stype',stype[0]);
                                        const asubitems = _classToSchema(atype);
                                        // asubitems.oryginalType = stype[0];
                                        prop.items = asubitems || { type: 'object', properties: {} };
                                    }
                                    prop.type = 'array';
                                    atype = '';
                                }
                            }
                            if (atype) {
                                prop.type = 'array';
                                prop.items = {
                                    type: atype
                                };
                            }
                            delete options.itemType;
                        }
                        break;
                    case 'String':
                        ntype = 'string';
                        break;
                    case 'Object':
                        ntype = 'object';
                        break;
                    case 'Boolean':
                        ntype = 'boolean';
                        break;
                    case 'Number':
                        ntype = 'number';
                        break;
                    case 'Function':
                        ntype = 'string';
                        // debugger;
                        break;
                    default: {
                        // tworznenie item
                        try {
                            let newprops = {};
                            if (t.prototype) {
                                newprops = _classToSchema(t);
                            }
                            else {
                                newprops = _classToSchema(ntype);
                            }
                            prop.type = 'object';
                            if (newprops) {
                                // prop = newprops;
                                prop.properties = newprops.properties;
                                if (newprops.$id) {
                                    prop.$id = newprops.$id;
                                }
                            }
                            else {
                                prop.properties = {};
                            }
                            /*
                                              // props[propertyKey] = _classToSchema(ntype);
                                              prop.type = 'object';
                                              // props[propertyKey].oryginalType = ntype;
                                              prop.properties = newprops.properties;
                                              if (newprops.$id) {
                                                  prop.$id = newprops.$id;
                                              }
                                              */
                            ntype = '';
                            /*
                                                            console.log("new "+ntype+"()");
                                                            let svalue = eval("new "+ntype+"()");
                                                            if (svalue) {
                                                                ntype = "";
                            
                            
                                                                let subschema = Reflect.getMetadata(SCHEMA_METADATA_KEY, svalue);
                                                                props[propertyKey] = subschema;
                            
                                                            }
                                                            */
                        }
                        catch (e) {
                            if (IOptions_1.defaultOptions.logErrors) {
                                console.error(e);
                            }
                        }
                    }
                }
                if (ntype) {
                    // console.log('define type of '+(propertyKey as string));
                    prop.type = ntype;
                }
                // console.log(propertyKey,ntype,t.name);
            }
        }
    }
    if (options) {
        mergeAndFixOptions(prop, options);
    }
    return prop;
}
/**
 * dodanei/pobranie schematu utoroznego dla wskazanej klasy
 *
 * @param {*} target definicja klasy
 * @returns {*}
 */
function getSchema(target, className) {
    const ctype = target.constructor;
    const cname = ctype.name;
    // const key = SCHEMA_METADATA_KEY;
    const key = 'schema_' + (className || cname);
    // let schema = Reflect.getMetadata(key, target);
    let schema = ctype.prototype[key];
    if (!schema) {
        // const ctype = target.constructor;
        /*
          const stype = ('' + ctype).split(' ');
          if (stype[0] === 'class' || stype[0] === 'function') {
            stype[0] = stype[1].replace('(', '').replace(')', '');
          }
          */
        // const cname = ctype.name;
        // console.log('getSchema', target, cname);
        schema = {
            type: 'object',
            $id: cname,
            properties: {}
        };
        // czy jest to klasa dziedzicząca
        const parent = Object.getPrototypeOf(target);
        if (parent && parent.constructor && parent.constructor.name && parent.constructor.name !== 'Object') {
            const parentSchema = getSchema(parent, parent.constructor.name);
            if (parentSchema && parentSchema.properties && Object.keys(parentSchema.properties).length) {
                schema.extends = parentSchema.$id;
                schema.properties = Object.assign({}, parentSchema.properties);
                Object.defineProperty(schema, 'ownProperties', {
                    enumerable: false,
                    value: {}
                });
            }
        }
        // Reflect.metadata(key, schema);
        // Reflect.defineMetadata(key, schema, target);
        ctype.prototype[key] = schema;
    }
    return schema;
}
function funcFromDescriptor(descriptor) {
    if (descriptor) {
        let s = '';
        if (descriptor.get) {
            // property get
            s = descriptor.get.toString();
        }
        else if (descriptor.value) {
            // method
            // debugger;
            s = descriptor.value.toString();
        }
        else {
            return undefined;
        }
        return (0, schemaFuncText_1.schemaFuncText)(s);
    }
    return undefined;
}
/**
 * wykonanie operacji na wskazanym property na podstawie opcji
 *
 * @export
 * @param {*} target docelowa klasa
 * @param {(string | symbol)} propertyKey nazwa property
 * @param {PropertyDescriptor} [descriptor] przekazy deskryptor
 * @param {*} [options] dodatkowe opcje
 * @returns {*}
 */
function runProperty(target, propertyKey, descriptor, options, ntype) {
    if (process.env.NODE_ENV !== 'production') {
        if (exports.startdecoratorstime === 0) {
            exports.startdecoratorstime = new Date().getTime();
        }
    }
    const schema = getSchema(target);
    const prop = getProperty(schema.ownProperties || schema.properties, propertyKey, target, options, ntype);
    schema.properties[propertyKey] = prop;
    if (descriptor && !prop.calc) {
        const func = funcFromDescriptor(descriptor);
        if (func) {
            prop.calc = func;
        }
    }
    return prop;
}
/*
function logType(target: any, key: string) {
  const t = Reflect.getMetadata('design:type', target, key);
  // console.log(`${key} type: ${t.name}`);
}
  */
/**
 * naprawianie typów danych w schemacie
 *
 * @param {*} schema schemat
 * @param {*} $root główna gałąż schematu
 * @returns {*}
 */
/*
function fixTypes(schema: any, $root: any): any {
  const result: any = {};
  for (const key in schema) {
    if (key !== 'properties') {
      result[key] = schema[key];
    }
  }
  result.properties = {};

  for (const prop in schema.properties) {
    if (schema.properties.hasOwnProperty(prop)) {
      const element = schema.properties[prop];
      if (element.type === 'object') {
        if (element.oryginalType !== undefined && $root) {
          if (!$root.definitions) {
            $root.definitions = {};
          }
          const def = $root.definitions[element.oryginalType];
          if (def === undefined) {
            const fixedtype = fixTypes(element, $root);
            $root.definitions[element.oryginalType] = {
              properties: fixedtype.properties
            };
            // $root.definitions[element.oryginalType] = fixTypes(element, $root);
          }
          result.properties[prop] = {
            properties: {
              $ref: '#/definitions/' + element.oryginalType
            }
          };

          // delete element.oryginalType;
        } else {
          result.properties[prop] = fixTypes(element, $root);
        }
      } else if (element.type === 'array') {
        const res: any = {};
        for (const key in element) {
          if (key !== 'items') {
            res[key] = element[key];
          }
        }
        res.items = {};

        result.properties[prop] = res;
        const items = element.items;

        if (items.type === 'object') {
          if (items.oryginalType !== undefined && $root) {
            if (!$root.definitions) {
              $root.definitions = {};
            }
            const def = $root.definitions[items.oryginalType];
            if (def === undefined) {
              $root.definitions[items.oryginalType] = fixTypes(items, $root);
            }
            res.items = {
              $ref: '#/definitions/' + items.oryginalType
            };
          } else {
            res.items = fixTypes(items, $root);
          }
        } else {
          res.items = items;
        }
      } else {
        result.properties[prop] = schema.properties[prop];
      }
    }
  }
  return result;
}
  */
/**
 * wewnętrzna funkcja do zamany klasy na schemat
 *
 * @export
 * @param {*} schemaClass
 * @returns {*}
 */
function _classToSchema(schemaClass, defaultsFromInstance = false) {
    // console.log('schemaClass',typeof schemaClass,schemaClass);
    if (typeof schemaClass === 'string') {
        // obj = eval('new ' + schemaClass + '()');
        // tslint:disable-next-line: no-eval
        schemaClass = eval2(schemaClass);
        // obj = new schemaClass();
    }
    const schema3 = schemaClass.prototype;
    // const ctype = schemaClass.constructor;
    const cname = schemaClass.name;
    // const key = SCHEMA_METADATA_KEY;
    const key = 'schema_' + cname;
    // const schema = Reflect.getMetadata(key, schema3);
    // const schema = Reflect.getMetadata(key, obj);
    const schema = schema3[key];
    if (schema && defaultsFromInstance) {
        const obj = new schemaClass();
        const schema2 = (0, fixAndMergeSchema_1.fixAndMergeSchema)([schema]);
        const props = schema2.properties;
        // domyślne wartości
        for (const key in obj) {
            // eslint-disable-next-line no-prototype-builtins
            if (obj.hasOwnProperty(key)) {
                const element = obj[key];
                if (element !== undefined) {
                    const prop = props[key];
                    if (prop !== undefined && prop.default === undefined) {
                        prop.default = element;
                    }
                }
            }
        }
        return schema2;
    }
    return schema;
}
/**
 * zamiana definicji klasy na schemat
 *
 * @export
 * @param {*} schemaClass klasa
 * @param {boolean} [useDefinitions=false] czyywać definicji (nie używane)
 * @returns {*}
 */
function classToSchema(schemaClass, defaultsFromInstance = false) {
    const schema = _classToSchema(schemaClass, defaultsFromInstance) || { type: 'object', properties: {} };
    return schema;
    // return schema;
}
/**
 * ogólna definicaj pola schematu
 *
 * @export
 * @param {JSONSchema} [options={}] opcje pola
 * @returns
 */
function SchemaProperty(options, ntype) {
    return (target, propertyKey, descriptor) => {
        if (target) {
            runProperty(target, propertyKey, descriptor, options, ntype);
        }
        else {
            if (ntype) {
                let newprops;
                if (ntype.prototype) {
                    newprops = _classToSchema(ntype);
                    if (newprops) {
                        options.type = 'object';
                        options.properties = newprops.properties;
                        if (newprops.$id) {
                            options.$id = newprops.$id;
                        }
                    }
                }
            }
            mergeAndFixOptions(options, options);
            return options;
        }
        // return JProp
    };
}
/**
 * definicja tablicy
 *
 * @export
 * @param {(string | any)} [itemType] typ elementu w tablicy
 * @param {JSONSchema} [options={}] pozostałe opcje tablicy
 * @returns
 */
function SchemaArray(itemType, options = {}) {
    options.itemType = itemType;
    return SchemaProperty(options, 'Array');
}
/**
 * pole z wartościami numerycznymi, zaokrąglonymi do 8 miejsc po przecinku
 *
 * @export
 * @param {JSONSchema} [options={}] dodatkowe opcje
 * @returns
 */
function SchemaNumber(options = {}) {
    options.type = 'number';
    return SchemaProperty(options);
}
/**
 * pole z wartościami wlutowymi, zaokrąglonymi do 2 miejsc po przecinku
 *
 * @export
 * @param {JSONSchema} [options={}] dodatkowe opcje
 * @returns
 */
function SchemaMoney(options = {}) {
    options.type = 'money';
    return SchemaProperty(options);
}
/**
 * pole z wartościami wlutowymi, zaokrąglonymi do 2 miejsc po przecinku
 *
 * @export
 * @param {JSONSchema} [options={}] dodatkowe opcje
 * @returns
 */
function SchemaInteger(options = {}) {
    options.type = 'integer';
    return SchemaProperty(options);
}
/**
 * pole z wartościami tekstowymi
 *
 * @export
 * @param {JSONSchema} [options={}] dodatkowe opcje
 * @returns
 */
function SchemaString(options = {}) {
    options.type = 'string';
    return SchemaProperty(options);
}
/**
 * pole wymagane
 *
 * @export
 * @param {JSONSchema} [options={}] dodatkowe opcje
 * @returns
 */
function SchemaRequired(options = {}) {
    options.fieldRequired = true;
    return SchemaProperty(options);
}
/**
 * pole z wartościami wlutowymi, zaokrąglonymi do 2 miejsc po przecinku
 *
 * @export
 * @param {JSONSchema} [options={}] dodatkowe opcje
 * @returns
 */
function SchemaBoolean(options = {}) {
    options.type = 'boolean';
    return SchemaProperty(options);
}
/**
 * ustawienie tytułu
 *
 * @export
 * @param {JSONSchema} [options={}] dodatkowe opcje
 * @returns
 */
function SchemaTitle(title) {
    return SchemaProperty({ title });
}
/**
 * pole akstowe o określonym formacie
 * @param format format
 * @param options dodatkowe opcje
 * @returns
 */
function SchemaFormat(format, options = {}) {
    options.type = 'string';
    options.format = format;
    return SchemaProperty(options);
}
/**
 * pole z wartościami wlutowymi, zaokrąglonymi do 2 miejsc po przecinku
 *
 * @export
 * @param {JSONSchema} [options={}] dodatkowe opcje
 * @returns
 */
function SchemaGuid(options = {}) {
    return SchemaFormat('guid', options);
}
/**
 * pole z wartościami data typu string
 *
 * @export
 * @param {JSONSchema} [options={}] dodatkowe opcje
 * @returns
 */
function SchemaDate(options = {}) {
    return SchemaFormat('date', options);
}
/**
 * pole z wartościami data+czas typu string
 *
 * @export
 * @param {JSONSchema} [options={}] dodatkowe opcje
 * @returns
 */
function SchemaDateTime(options = {}) {
    return SchemaFormat('date-time', options);
}
/**
 * pole z wartościami nip typu string
 *
 * @export
 * @param {JSONSchema} [options={}] dodatkowe opcje
 * @returns
 */
function SchemaNip(options = {}) {
    return SchemaFormat('nip', options);
}
/**
 *
 * @param objectType typ obiektu, string albo typ
 * @param options
 * @returns
 */
function SchemaObject(objectType, options = {}) {
    return SchemaProperty(options, objectType);
}
function SchemaAggregate(opt) {
    return SchemaProperty({
        aggregate: opt
    });
}
function SchemaDef(options = {}) {
    return (target, propertyKey, descriptor) => {
        if (descriptor) {
            let func = null;
            if (descriptor.get) {
                // property get
                func = descriptor.get;
            }
            else if (descriptor.value) {
                // method
                // debugger;
                func = descriptor.value;
            }
            else {
                return null;
            }
            const obj = func();
            for (const key in obj) {
                const v = obj[key];
                if (typeof v === 'function') {
                    obj[key] = (0, schemaFuncText_1.schemaFuncText)(v.toString());
                }
            }
            if (options.max2) {
                options.max2 = (0, schemaFuncText_1.schemaFuncText)(options.max2.toString());
            }
            if (options.max3) {
                options.max3 = (0, schemaFuncText_1.schemaFuncText)(options.max3.toString());
            }
            return runProperty(target, propertyKey, undefined, Object.assign(Object.assign({}, options), obj));
        }
        // return JProp
    };
}
/**
 * ustawienie opcji na całą definicję klasy
 *
 * @export
 * @param {JSONSchema} [options={}] opcje
 * @returns
 */
function SchemaClass(options = {}) {
    return (constructor) => {
        /*
                return class extends constructor {
                    newProperty = "new property";
                    hello = "override";
                }
                */
        const cname = constructor.name;
        // const key = SCHEMA_METADATA_KEY;
        const key = 'schema_' + cname;
        const schema = Reflect.getMetadata(key, constructor);
        //const schema = constructor.prototype.__schema;
        if (schema) {
            for (const key in options) {
                // eslint-disable-next-line no-prototype-builtins
                if (options.hasOwnProperty(key)) {
                    // const element = options[key];
                    switch (key) {
                        case 'validationMessages':
                        case 'warningMessages':
                        case 'methods':
                            schema[key] = Object.assign(schema[key] || {}, options[key]);
                            break;
                        default:
                            schema[key] = options[key];
                            break;
                    }
                }
            }
        }
        return constructor;
    };
}
/**
 * ustawienie opcji na całą definicję klasy
 *
 * @export
 * @param {JSONSchema} [options={}] opcje
 * @returns
 */
function SchemaOptions(options = {}) {
    return (constructor) => {
        /*
                return class extends constructor {
                    newProperty = "new property";
                    hello = "override";
                }
                */
        const cname = constructor.name;
        // const key = SCHEMA_METADATA_KEY;
        const key = 'schema_' + cname;
        // const schema = Reflect.getMetadata(key, constructor);
        //const schema = constructor.prototype.__schema;
        const schema = constructor.prototype[key];
        // ctype.prototype[key]
        let $options = null;
        if (schema) {
            for (const key in options) {
                if (!$options) {
                    $options = schema.$options;
                    if (!$options) {
                        $options = schema.$options = {};
                    }
                }
                const element = options[key];
                switch (key) {
                    case 'validationMessages':
                    case 'warningMessages':
                    case '$methods':
                        $options[key] = Object.assign($options[key] || {}, element);
                        break;
                    default:
                        $options[key] = element;
                        break;
                }
            }
        }
        return constructor;
    };
}
function SchemaValidation(fieldOrFields = null, typeOrTypes = null) {
    if (typeof fieldOrFields === 'string') {
        fieldOrFields = [fieldOrFields];
    }
    if (typeof typeOrTypes === 'string') {
        typeOrTypes = [typeOrTypes];
    }
    return (target, propertyKey, descriptor) => {
        if (fieldOrFields === null) {
            const tt = propertyKey.toString().split('_');
            fieldOrFields = [tt[0]];
            if (typeOrTypes === null) {
                typeOrTypes = [tt[1]];
            }
        }
        if (typeOrTypes === null) {
            return;
        }
        if (descriptor) {
            const func = funcFromDescriptor(descriptor);
            const funci = func ? (typeof func === 'string' ? +func : NaN) : NaN;
            const schema = getSchema(target);
            if (schema) {
                const fprops = schema.ownProperties || schema.properties;
                for (const fieldName of fieldOrFields) {
                    const prop = fprops[fieldName];
                    if (prop) {
                        for (const vtype of typeOrTypes) {
                            prop[vtype] = func;
                            if (!isNaN(funci)) {
                                switch (vtype) {
                                    case 'length':
                                    case 'minimum':
                                    case 'maximum':
                                    case 'exclusiveMaximum':
                                    case 'exclusiveMinimum':
                                    case 'multipleOf':
                                    case 'maxLength':
                                    case 'minLength':
                                    case 'maxItems':
                                    case 'minItems':
                                        prop[vtype] = funci;
                                        break;
                                }
                            }
                        }
                    }
                }
            }
        }
        // return JProp
    };
}
exports.JProp = {
    // Property: SchemaProperty,
    Number: SchemaNumber,
    Integer: SchemaInteger,
    Money: SchemaMoney,
    String: SchemaString,
    Format: SchemaFormat,
    Date: SchemaDate,
    DateTime: SchemaDateTime,
    Nip: SchemaNip,
    Guid: SchemaGuid,
    Boolean: SchemaBoolean,
    Array: SchemaArray,
    Object: SchemaObject,
    Required: SchemaRequired,
    Title: SchemaTitle,
    Valid: SchemaValidation,
    Aggregate: SchemaAggregate
    // Calc: SchemaCalc
};
exports.$methods = schemaMethods;
//# sourceMappingURL=classToSchema.js.map